import { intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as StatusId } from '../../../../job/status/Id';

export const Request = intersect(
	struct({
		statusId: StatusId,
	})
)(
	partial({
		estimateManagementLost: struct({
			reasonCode: string,
			notes: nullable(string),
		}),
		estimateManagementOnHold: struct({
			reasonCode: string,
			notes: nullable(string),
		}),
		orderManagementOnHold: struct({
			reasonCode: string,
			notes: nullable(string),
		}),
		//
		reminder: struct({
			scheduledAt: iotsUtils.ValidDate,
		}),
	})
);
